export const getters = {
  packageInformation(state) {
    return state.claimCenter.packageInformation;
  },
};
